module.exports = __webpack_public_path__ + "img/1_3.987d09a1.jpg";